module.exports = __webpack_public_path__ + "img/christmas-hero.8230fce4.jpg";